import {
    captureConsoleIntegration,
    replayIntegration,
    browserTracingIntegration
} from "@sentry/react";
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import "./i18n";
import "./index.css";
import { useOfflineFallbackPage } from "./components/hooks/useOfflineFallbackPage";

if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        maxValueLength: 8192,
        integrations: [
            browserTracingIntegration(),
            replayIntegration(),
            captureConsoleIntegration({ levels: ["error", "assert"] })
        ],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0
    });
} else {
    console.warn("Could not find Sentry DSN. Skipping Sentry setup.");
}

useOfflineFallbackPage();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
